/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartialHeatLoadsRequestPost } from '../../models/partial-heat-loads-request-post';
import { PartialHeatLoadsResponse } from '../../models/partial-heat-loads-response';

export interface CalculationsControllerPartialHeatLoads$Params {
      body: PartialHeatLoadsRequestPost
}

export function calculationsControllerPartialHeatLoads(http: HttpClient, rootUrl: string, params: CalculationsControllerPartialHeatLoads$Params, context?: HttpContext): Observable<StrictHttpResponse<PartialHeatLoadsResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerPartialHeatLoads.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartialHeatLoadsResponse>;
    })
  );
}

calculationsControllerPartialHeatLoads.PATH = '/planning-projects/v1-develop/calculations/partial-heat-loads';
